import { render } from "./CardCartao.vue?vue&type=template&id=73216a7e&scoped=true"
import script from "./CardCartao.vue?vue&type=script&lang=js"
export * from "./CardCartao.vue?vue&type=script&lang=js"

import "./CardCartao.vue?vue&type=style&index=0&id=73216a7e&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\comprodonto_site_v4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73216a7e"]])

export default __exports__